export const BASE_API_URL = "https://foknje7ek.com:8081/api/v1/";